import axios from "axios";
import {apiJavaURL} from "@/api/config";
import {setAuthInHeader} from "@/api/request";

let isSessionInvalidated = false;

export const markSessionInvalidated = (value) => {
    isSessionInvalidated = value;
};

export const getIsSessionInvalidated = () => {
    return isSessionInvalidated;
};

export const clearSession = () => {
    isSessionInvalidated = true;
    delete window.__RAINBOW_VOLATILE_TOKEN__;
    window.localStorage.clear();
    setAuthInHeader('');
};

export const logout = async ($this = null) => {
    try {
        await axios.delete(`${apiJavaURL}v1/member/WEB/logout`);
    } catch (e) {
        // 서버 로그아웃 실패와 관계없이 로컬 세션은 정리합니다.
    }

    clearSession();

    if ($this) {
        $this.$router.replace('/auth');
    } else {
        location.href = '/';
    }
};
